import { Role } from '@99designs/site-navigation/consts';

export function getRoleFromUser(
    user: { __typename: 'User'; isAdmin: boolean; isDesigner: boolean } | null
): Role {
    if (!user) {
        return 'logged-out';
    } else if (user.isAdmin) {
        return 'contest-holder';
    } else if (user.isDesigner) {
        return 'designer';
    } else {
        return 'contest-holder';
    }
}
